// Labels every team profile shares, Spanish: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Datos personales',
    rows: {
      name: 'Nombre',
      position: 'Cargo',
      birthdate: 'Fecha de nacimiento',
      nationality: 'Nacionalidad',
      maritalStatus: 'Estado civil',
      location: 'Ubicación',
      languages: 'Idiomas',
      programmingLanguages: 'Lenguajes de programación',
      certifications: 'Certificaciones',
      publications: 'Publicaciones',
      links: 'Sitio web'
    }
  },
  education: {
    title: 'Formación académica'
  },
  skills: {
    title: 'Competencias especializadas'
  },
  experience: {
    title: 'Proyectos y actividades',
    techLabel: 'Tecnologías'
  },
  downloads: {
    title: 'Descargar el perfil',
    deLabel: 'Descargar el perfil en alemán',
    deDescription: 'PDF en alemán',
    enLabel: 'Descargar el CV en inglés',
    enDescription: 'PDF en inglés'
  },
  cta: {
    title: 'Contacto',
    button: 'Contactar'
  },
  pdf: {
    title: 'Perfil',
    personalSection: 'Datos personales',
    educationSection: 'Formación académica',
    experienceSection: 'Proyectos y actividades',
    skillsLabel: 'Competencias'
  }
};
